module.exports = __webpack_public_path__ + "static/media/goods7_1.2a93ddb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods7_1.png
// module id = 1237
// module chunks = 0